// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

// const toolbar = ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript', 'hr bullist numlist link charmap preview anchor insertdatetime imageupload table emoticons forecolor backcolor fullscreen']

const toolbar = [
    ' undo redo searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote hr',
    'formatselect fontsizeselect fontselect link charmap anchor insertdatetime imageupload table  forecolor backcolor'
]

export default toolbar
